import React, { useEffect, useState, forwardRef } from 'react';
import { formatDateTimeForInput } from '../../../functions/formatDateTime';

const handleSetNow = (type, date=null) => {
  var sliceTo = 16
  if(type==='date'){
    sliceTo = 10
  }
  if(date===null){
    date = Date.now()
  }
  return new Date(date - new Date().getTimezoneOffset()* 60000)
    .toISOString()
    .slice(0, sliceTo);
};


const Input = forwardRef(({
  fieldName,
  wrapperClass = '',
  label,
  hideLabel = false,
  allowNull = true,
  inputType = 'text',
  value = '',
  step,
  errors = [],
  helpText = '',
  parent = '',
  autofocus = false,
  disabled = false,
  width = '',
  style = {},
  many = false,
  onChange = () =>  {},
  pk = null
}, ref) => {
  const [inputValue, setInputValue] = useState(value);
  const localOnChange = (e) => {
    setInputValue(e.target.value)
    onChange({'name':fieldName, 'type': 'change', 'value': e.target.value, 'label': e.target.value})
  }
  const onBlur = (e) => {
    onChange({'name':fieldName, 'type': 'blur', 'value': e.target.value, 'label': e.target.value})
  }
  useEffect(() => {
    setInputValue(value)
  }, [value])
  if (inputType === 'file') {
    return (
        <input
          id={pk ? pk + '_' + fieldName : fieldName}
          ref={ref}
          name={fieldName}
          className={`form-control ${errors.length > 0 ? 'is-invalid' : ''}`}
          type="file"
          size="50"
          onChange={localOnChange}
          multiple={many}
        />
    );
  }
  if(inputType === 'datetime-local'){
    value = formatDateTimeForInput(value);
  }
  return <>
      {/* {['datetime-local', 'date'].includes(inputType) && (
        <span
          className="dateSetter"
          type="button"
          onClick={(e) => handleSetNow(e, inputType)}
        >
          {inputType === 'datetime-local' ? 'Set Now' : 'Set Today'}
        </span>
      )} */}
      <input
        ref={ref}
        id={pk ? pk + '_' + fieldName : fieldName}
        name={fieldName}
        className={`form-control ${style.class} ${errors.length > 0 ? 'is-invalid' : ''}`}
        type={inputType}
        placeholder={style.placeholder}
        value={inputValue || ''}
        step={step}
        data-char_select_parent={parent}
        autoFocus={autofocus && inputType !== 'hidden'}
        disabled={disabled}
        onBlur={onBlur}
        onChange={localOnChange}
      />
    </>
});

export default Input;